import type { StorageService } from './storage.interface.ts'

export function createLocalStorageService(): StorageService {
  return {
    get<T>(key: string): T | null {
      try {
        const item = localStorage.getItem(key)
        return item ? (JSON.parse(item) as T) : null
      } catch {
        return null
      }
    },

    set<T>(key: string, value: T): void {
      try {
        localStorage.setItem(key, JSON.stringify(value))
      } catch {
        console.error(`Failed to set storage key "${key}"`)
      }
    },

    remove(key: string): void {
      localStorage.removeItem(key)
    },

    clear(): void {
      localStorage.clear()
    },

    has(key: string): boolean {
      return localStorage.getItem(key) !== null
    },
  }
}
